// extracted by mini-css-extract-plugin
export var actionButton = "_nh-0";
export var actionMenuContainer = "_nh-i";
export var bubble = "_nh-2";
export var bubbleActionMenu = "_nh-j";
export var bubbleContext = "_nh-6";
export var bubbleItems = "_nh-7";
export var customer = "_nh-3";
export var divider = "_nh-8";
export var fileList = "_nh-9";
export var hiddenComment = "_nh-o";
export var infoAbove = "_nh-a";
export var internal = "_nh-4";
export var lightActionButton = "_nh-1";
export var link = "_nh-b";
export var merchant = "_nh-5";
export var message = "_nh-c";
export var profilePicture = "_nh-e";
export var quillToolbarContainer = "_nh-f";
export var senderDate = "_nh-g";
export var senderDateCustomer = "_nh-h";
export var senderName = "_nh-d";
export var time = "_nh-k";
export var uploadedImage = "_nh-l";
export var username = "_nh-m";
export var xsmall = "_nh-n";